<template>
  <div class="doctor-index">
    <div class="banner-wrapper">

      <swiper :options="swiperOption">
        <swiper-slide class="swiper-slide" v-for="(item,index) in bannerArr" :key="index">
          <img :src="item" @click="toDetail(index)" />
        </swiper-slide>
        <!-- 分页器 npm install --save vue-awesome-swiper -->
        <!--  <div class="swiper-pagination" slot="pagination"></div>-->
        <!-- 左右箭头 -->
        <!--  <div class="swiper-button-prev" slot="button-prev"></div>-->
        <!--  <div class="swiper-button-next" slot="button-next"></div>-->
      </swiper>

      <!--
      <div class="banner" @click="toDetail()">
        <img :src="bindBanner">
      </div>
      -->
      <div class="banner-data-wrapper">
        <div class="banner-data">
          <div class="data-item">
            <h3>{{docData.patient_num || 0}}</h3>
            <p>本月患者数</p>
          </div>
          <div class="data-item">
            <h3>{{docData.prescription_num || 0}}</h3>
            <p>本月开方数</p>
          </div>
          <div class="data-item">
            <h3>{{docData.enrollers_num || 0}}</h3>
            <p>本月挂号数</p>
          </div>
        </div>
      </div>
    </div>
    <div class="index-main">
      <router-link tag="div" to="/doctor/consulting-room" class="doctor-notice" v-if="docData.num > 0">
        <div class="notice-text">
          <icon icon-class="notice"></icon>
          <p>您有<span>{{docData.num}}</span>位患者正在诊疗</p>
        </div>
        <div class="notice-link">
          <span>立即查看</span>
          <van-icon name="arrow" />
        </div>
      </router-link>
      <div class="doctor-menu">
        <div class="menu-item">
          <router-link to="/doctor/my-patients">
            <icon icon-class="my-patient"></icon>
            <div class="item-text">我的患者</div>
          </router-link>
        </div>

        <div class="menu-item">
          <router-link to="/face-to-face">
            <img src="@/assets/images/icons/face_to_faces_icon.png" style="width: 40px;" />
            <div class="item-text">面对面开方</div>
          </router-link>
        </div>

        <div class="menu-item" v-if="userInfo.doctor_type == 1">
          <router-link to="/prescription">
            <icon icon-class="medication"></icon>
            <div class="item-text">处方模板</div>
          </router-link>
        </div>
        <div class="menu-item">
          <router-link to="/doctor/schedule-catalog" >
            <icon icon-class="schedule"></icon>
            <div class="item-text">诊疗日程</div>
          </router-link>

        </div>
        <div class="menu-item">
          <router-link to="/invite-patient">
            <icon icon-class="invite-patient"></icon>
            <div class="item-text">邀请患者</div>
          </router-link>
        </div>
        <div class="menu-item">
          <router-link to="/invite-doctor">
            <icon icon-class="invite-doctor"></icon>
            <div class="item-text">邀请医生</div>
          </router-link>
        </div>
        <div class="menu-item">
          <router-link to="/classical-prescription">
            <icon icon-class="classical"></icon>
            <div class="item-text">经方</div>
          </router-link>
        </div>

        <div class="menu-item">
          <router-link to="/private-prescription">
            <img src="@/assets/images/icons/private-icon-main.png" style="width: 40px;" />
            <div class="item-text">协定方</div>
          </router-link>
        </div>
        <div class="menu-item">
          <router-link :to="articleLink">
            <img src="@/assets/images/icons/icon-article.png" style="width: 40px;" />
            <div class="item-text">学术文章</div>
          </router-link>
        </div>

      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .private-icon{

   }
  .banner-wrapper{
    position: relative;
    width: 100%;
    height: 211px;
    .swiper-slide{
      position: relative;
      width: 100%;
      height: 211px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      text-align: center;
      overflow: hidden;
      z-index:1;
      img{
        width: 100%;
        max-width: 600px;
      }
    }
    .swiper-button-prev{
      color:#55aaff;
     }
     .swiper-button-next{
        color:#55aaff;
     }
    .banner{
      position: relative;
      width: 100%;
      height: 211px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      text-align: center;
      overflow: hidden;
      img{
        width: 100%;
        max-width: 600px;
      }
    }
    .banner-data-wrapper{
      position: absolute;
      left: 0;
      bottom: -29px;
      padding: 0 16px;
      width: 100%;
      z-index:21;
      .banner-data{
        width: 100%;
        height: 84px;
        border-radius: 4px;
        box-shadow: 0px 4px 10px 0px rgba(51,51,51,0.08);
        background: #FFF;
        display: flex;
        justify-content: space-around;
        align-items: center;
        .data-item{
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          h3{
            font-size: 28px;
            line-height: 28px;
            color: @xile;
            font-weight: normal;
          }
          p{
            font-size: 13px;
            line-height: 13px;
            margin-top: 8px;
            color: @black;
          }
        }
      }
    }
  }
  .index-main{
    padding: 29px 16px 0;
    .doctor-notice{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 12px;
      padding: 0 14px 0 16px;
      width: 100%;
      height: 38px;
      box-shadow: 0px 4px 10px 0px rgba(51,51,51,0.08);
      border-radius: 4px;
      font-size: 14px;
      .notice-link{
        color: #999;
        display: flex;
        align-items: center;

        .van-icon{
          margin-left: 4px;
          font-size: 16px;
        }
      }
      .notice-text{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        svg{
          font-size: 16px;
          margin-right: 5px;
          color: @xile;
        }
        p{
          color: @black;
          font-size: 14px;
          span{
            font-size: 14px;
            margin: 0 4px;
            color: @xile;
          }
        }
      }
    }
    .doctor-menu{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      margin-top: 38px;
      .menu-item{
        width: 33.333%;
        text-align: center;
        margin-bottom: 42px;
        svg{
          font-size: 40px;
          color: @xile;
        }
        .item-text{
          margin-top: 4px;
          font-size: 13px;
          line-height: 13px;
          color: @black;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {

    data() {
      return {
        swiperOption: {
          //显示分页
          pagination: {
            el: '.swiper-pagination'
          },
          //设置点击箭头
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          //自动轮播
          autoplay: {
            delay: 3000,
            //当用户滑动图片后继续自动轮播
            disableOnInteraction: false,
          },
          //开启循环模式
          loop: true
        },
        docData: {},
        articleLink: '',
        bannerArr: [
          require('@/assets/images/banner.png'),
          require('@/assets/images/doc-banner.jpg'),
          require('@/assets/images/yan-doc.jpg')
        ],
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    mounted() {

    },
    created() {
      let _this = this;

      //this.userInfo.user_id=10035
      this.$root.post('/getIndexInfo', {
        doc_id: this.userInfo.user_id
      }).then(data => {
        this.docData = data;
      })
      this.articleLink = '/article?doc_id=' + this.userInfo.user_id;
    },
    //beforeRouteLeave(to, from, next){

    // },
    methods: {
      toDetail(index) {
        switch(index){
          case 1:
          this.$router.push({
            path: '/banner1'
          });
          break;
          case 2:
          this.$router.push({
            path: '/banner2'
          });
          break;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Index/indexPage.vue